exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".jira[data-v-38525bc4]{position:fixed;bottom:auto;left:0;top:10px;color:#fff;z-index:999;background-color:#000;padding:.4rem .75rem;border:0;border-bottom-right-radius:8px;border-top-right-radius:8px;font-size:1rem;border-bottom:0 solid #666}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-38525bc4","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Jira.vue
// module id = 77
// module chunks = 0